module.exports = __webpack_public_path__ + "static/media/high-twoedge-3.fee02076.png";